import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { When } from 'react-if';

import { Loading } from '../loading';
import { ButtonProps, ButtonShape, ButtonSize } from './button.types';

const sizeClasses: Record<ButtonSize, string> = {
  small: 'btn-sm',
  medium: '',
  large: 'btn-lg',
};

const shapeClasses: Record<ButtonShape, string> = {
  wide: 'btn-wide',
  full: 'btn-block',
  circle: 'btn-circle',
  default: '',
};

export const Button: React.FC<ButtonProps> = ({
  Icon,
  textKey,
  variant,
  LeftIcon,
  className,
  RightIcon,
  isLink = false,
  linkType = 'primary',
  type = 'button',
  size = 'medium',
  shape = 'default',
  isLoading = false,
  isDisabled = false,
  loadingType = 'spinner',
  ...rest
}: ButtonProps) => {
  const { t } = useTranslation();

  const classes = classNames(
    'btn',
    className,
    { [`btn-${variant}`]: variant },
    { [sizeClasses[size]]: size },
    { [`btn-link-${linkType}`]: isLink },
    { [shapeClasses[shape]]: shape },
    { 'pointer-events-none opacity-80': isLoading }
  );

  return (
    <button type={type} disabled={isDisabled} className={classes} {...rest}>
      <When condition={isLoading}>
        <Loading type={loadingType} />
      </When>
      {LeftIcon && <LeftIcon />}
      {Icon ? <Icon /> : <Trans t={t}>{textKey}</Trans>}
      {RightIcon && <RightIcon />}
    </button>
  );
};
